import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export type ViewType = 'all' | 'persons' | 'account-owners';

interface ViewOption {
    value: ViewType;
    label: string;
}

const VIEW_OPTIONS: ViewOption[] = [
    { value: 'all', label: 'Households' },
    { value: 'persons', label: 'Persons' },
    { value: 'account-owners', label: 'Account Owners' },
];

export const ViewSelector = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const viewParam = searchParams.get('view');
    const currentView = VIEW_OPTIONS.some((option) => option.value === viewParam) ? (viewParam as ViewType) : 'all';

    const handleViewChange = (value: string) => {
        const view = value as ViewType;
        if (view === 'all') {
            // Remove the query param for the default view
            navigate('/household', { replace: true });
        } else {
            navigate(`/household?view=${view}`, { replace: true });
        }
    };

    return (
        <Select value={currentView} onValueChange={handleViewChange}>
            <TooltipProvider delayDuration={100}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <SelectTrigger className="text-cocoa-1000 hover:text-cocoa-900 font-heading h-auto w-auto cursor-pointer gap-1 border-0 bg-transparent p-0 text-3xl font-medium shadow-none focus:ring-0 focus:ring-offset-0 [&>svg]:mt-0.5 [&>svg]:opacity-100">
                            <SelectValue />
                        </SelectTrigger>
                    </TooltipTrigger>
                    <TooltipContent side="bottom">Change View</TooltipContent>
                </Tooltip>
            </TooltipProvider>
            <SelectContent>
                {VIEW_OPTIONS.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                        {option.label}
                    </SelectItem>
                ))}
            </SelectContent>
        </Select>
    );
};
